import { ComboboxItem, Group, Select } from '@mantine/core';

import {
  HierarchyDisciplineSelect,
  HierarchyDisciplineSelectProps,
} from '@feature/utils/components/HierarchyDisciplineSelect';

export interface HierarchyDepartmentSelectProps extends HierarchyDisciplineSelectProps {
  departmentOptions: ComboboxItem[];
  departmentValue: string | null;

  onDepartmentChange: (_value: string | null, option: ComboboxItem) => void;
}

export function HierarchyDepartmentSelect(props: HierarchyDepartmentSelectProps) {
  const { departmentOptions, departmentValue, onDepartmentChange, isDisabled, ...restProps } = props;

  return (
    <Group>
      <Select
        flex={0.6}
        label="Departament"
        placeholder="Departament"
        searchable
        data={departmentOptions}
        disabled={isDisabled}
        value={departmentValue}
        onChange={onDepartmentChange}
      />
      <HierarchyDisciplineSelect
        isDisabled={departmentValue == null || isDisabled}
        {...restProps}
      />
    </Group>
  );
}
